export const unauthorized = 'Требуется войти в аккаунт';
export const slowNetwork =
    'Не удается подключиться к серверу. Попробуйте еще раз через несколько минут.';
export const unhandledNetworkIssue =
    'Произошла непредвиденная ошибка. Попробуйте еще раз через несколько минут. При необходимости напишите в поддержку.';
export const unpaid = 'Оплаченный период закончился';
